import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIAsksChoiceWrapper } from './components/AIAsksChoiceWrapper';

async function loadAIAsksChoiceStep(): Promise<typeof AIAsksChoiceWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-asks-choice" */ './components/AIAsksChoiceWrapper'
		)
	).AIAsksChoiceWrapper;
}

export const AIAsksChoiceLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAIAsksChoiceStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadAIAsksChoiceStep = loadAIAsksChoiceStep;
